<template>
  <div id="app" class="flex h-100 flex-wrap pagebg" style="overflow: hidden">
    <div @click="back()" class="power">
      <i style="cursor: pointer; font-size: 0.6rem" class="el-icon-back"></i>
    </div>
    <div class="otherReport">
      <!-- <img @click="d8Process()" style="height: 0.6rem" src="../../../assets/img/fr/table.png" /> -->
    </div>
    <div class="logoImg">
      <img style="height: 0.8rem" :src="logoSrc" />
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <!-- <h3 class="title">快速反应跟踪</h3> -->
      <div class="font-big font-weight light-title">
        {{ title ? title : "待响应清单" }}
      </div>
      <!-- <el-button class="title" type="primary">{{ title }}</el-button> -->
    </header>
    <div style="text-align: center; margin-top: 20px;width:100%" v-if="leftValue.length < 1">
      <h1 style="color: white; font-size: 20px">没有进行中的数据!</h1>
    </div>
    <div class="p w-100" style="overflow-x: scroll">

      <el-carousel style="height: 1024px" direction="vertical" :interval="too">
        <el-carousel-item style="height: 1024px" v-for="carou in screen" :key="carou">
          <div class="table-show">
            <table class="table-wrapper">
              <thead>
                <tr
                  style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
                  <th v-for="(val, i) in leftHeader" rowspan="2" :key="'leftHeader-' + i + '-h-' + carou"
                    class="light-title" style="font-size: 0.353333rem">
                    {{ val }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tr, ind) in dataSlice(carou, leftValue)" :key="'leftValue-' + ind">
                  <td>
                    {{ ind + 1 }}
                  </td>
                  <td>
                    {{ tr.code }}
                  </td>
                  <td>
                    {{ formatDate(tr.openedDate) }}
                  </td>
                  <td>{{ tr.SN }}</td>
                  <td><span v-if="tr.creator">{{ tr.creator.name }}</span></td>
                  <td>
                    <span v-if="tr.productionLine">{{ tr.productionLine.title }} </span>
                  </td>
                  <td>{{ removeTAG(tr.description) }}</td>
                  <td>
                    <span v-if="tr.source">{{ tr.source.title }} </span>
                  </td>
                  <td>
                    <span v-if="tr.owner">{{ tr.owner.name }} </span>
                  </td>
                  <td class="ratifyBtn" @click="oepnIssueDialog(tr)">批准</td>
                  <td class="rejectBtn" @click="oepnIssueDialog(tr)">拒绝</td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" title="问题待响应确认" :visible.sync="issueDialog"
      width="35%">
      <span v-html="issueData.description"></span>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="approveLoading" type="primary" @click="issueReponse(issueData)">确认问题</el-button>
        <el-button :loading="approveLoading" type="danger" @click="issueReject(issueData)">拒绝问题</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import router from "../../../router";
import format from "date-fns/format";
export default {
  name: "response-board",
  data() {
    return {
      websock: null,
      reconnectData: null,
      lockReconnect: false,
      logoSrc: "/assets/img/logo_light.png",
      title: "待响应清单",
      msg: "home",
      leftHeader: [], // 表头;
      leftValue: [], // 值;
      rightTopHeader: [], // 表头;
      rightTwoHeader: [], // 二级表头;
      rightValue: [], // 值;
      loading: null,
      issueDialog: false,
      issueData: {},
      colors: { Y: "#FFCC00", R: "#f44", G: "#06bf04" },
      todoTitle: { title: "", groupTitle: "" },
      screen: 1,
      pageSize: 16,
      too: 10000,
      approveLoading: false,
    };
  },
  mounted() {
    this.onShow();
    this.loadBoardTitle();
    // 初始化
    this.startLoading();
    this.webSocket();
    this.init(); //保留http
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  filters: {},
  methods: {
    d8Process() {
      this.$router.push({
        path: "/fr/board",
        query: {
          key: this.$route.query.key,
        }
      });
    },
    oepnIssueDialog(item) {
      this.issueData = item;
      this.issueDialog = true;
    },

    loadBoardTitle() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }
      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });
    },

    oepnTodoDialog(item) {
      if (!item.process) {
        return;
      }
      this.todoDialog = true;
      this.todoTitle["title"] = item.title;
      this.todoTitle["groupTitle"] = item.groupTitle;

      API.getProcess(item.issue, item.process)
        .then((res) => {
          if (res.success === true) {
            this.todoData = res.value;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    formatRate(data) {
      if (data.total > 0) {
        return parseInt(((data.completed / data.total) * 100).toFixed(0));
      } else {
        return 100;
      }
    },

    start: function () {
      setTimeout(() => {
        this.end(); //娃娃消失
      }, 4000);
    },

    init() {
      this.leftHeader = [
        "序号",
        "事件编号",
        "开始日期",
        "呼叫人",
        "响应人",
        "区域",
        "问题描述",
        "问题来源",
        "所有人",
        "批准",
        "拒绝",
      ];
      this.loadData();
    },

    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);

        const params = {'query':{}};
        var key = this.$route.query.key;
        if (key) {
          params['query']['processCategoryUUID'] = key;
        }

        API.getResponse(params)
          .then((res) => {
            if (res.success === true) {
              this.format(res.list);
            }
          })
          .catch((error) => {
            this.endLoading();
            console.log(error);
          });
      }
    },

    //格式化数据
    format(res) {
      this.leftValue = [];
      this.leftValue = res;
      this.screen = Math.ceil(res.length / this.pageSize);
      this.endLoading();
    },
    //响应
    issueReponse(item) {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        const params = { issueUUID: item["uuid"] };
        this.approveLoading = true;
        API.frConfirmResponse(params)
          .then((res) => {
            if (res.success === true) {
              this.$message.success("操作成功!");
              this.issueDialog = false;
              this.loadData();
            } else {
              this.$message.error(res.message);
            }
            this.approveLoading = false;
          })
          .catch((error) => {
            this.approveLoading = false;
            console.log(error);
          });
      }
    },
    //拒绝
    issueReject(item) {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        const params = { issueUUID: item["uuid"] };
        this.approveLoading = true;
        API.frConfirmReject(params)
          .then((res) => {
            if (res.success === true) {
              this.$message.success("操作成功!");
              this.issueDialog = false;
              this.loadData();
            } else {
              this.$message.error(res.message);
            }
            this.approveLoading = false;
          })
          .catch((error) => {
            this.approveLoading = false;
            console.log(error);
          });
      }
    },
    dataSlice(index, data) {
      var open = (index - 1) * this.pageSize;
      var end = index * this.pageSize;
      return data.slice(open, end);
    },

    webSocket() {
      var http = sessionStorage.getItem("http");
      var uuid = this.$route.query.key;
      if (http) {
        http += "/websocket/fr/issue/keep";
      } else {
        http = "https://demo.biqs.cn/websocket/fr/issue/keep";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      // window.addEventListener("resize", function() {
      //   myChart.resize();
      // });
    },
    //连接成功
    websocketonopen() {
      console.log("FR socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("FR socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log(" FR socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      //刷新
      this.init();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    onShow() {
      localStorage.getItem("setUp");
      var setUp = localStorage.getItem("setUp");
      if (setUp) {
        setUp = JSON.parse(setUp);
        this.pageSize = setUp["pageSize"];
        this.too = setUp["too"] * 1000;
      }
    },
    removeTAG(str) {
      if (str) {
        return str.replace(/<[^>]+>/g, "");
      } else {
        return str;
      }
    },
    formatDate(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "yyyy-MM-dd");
      }
      return "";
    },
    formatHour(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "MM/dd HH:mm");
      }
      return "";
    },
    back() {
      router.back();
    },
  },
};
</script>
<style>
.pagebg {
  background: url("../../../assets/img/8dbg.png");
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/fr/response/board.vue